import Enum from '/@/modules/core/app/helpers/Enum';

export class EstateConsentType extends Enum {
  static CONSENT_FOR_PARTNER_TO_ACCESS_ESTATE_ACCOUNT =
    'consent_for_partner_to_access_estate_account';
  static CONSENT_FOR_TRUE_CERTIFIED_COPY_OF_WILL = 'consent_for_true_certified_copy_of_will';
  static CONSENT_FOR_TRUE_CERTIFIED_COPY_OF_PROTECTION_MANDATE =
    'consent_for_true_certified_copy_of_protection_mandate';
  static CONSENT_TO_THE_PROFESSIONAL_EXECUTOR_FEE_SCHEDULE =
    'consent_to_the_professional_executor_fee_schedule';
  static CONSENT_TO_TERMS_OF_USE = 'consent_to_terms_of_use';
  static CONSENT_TO_PRIVACY_POLICY = 'consent_to_privacy_policy';
  static CONSENT_TO_PLANNING_PURCHASE_TERMS = 'consent_to_planning_purchase_terms';
  static CONSENT_TO_AFTERCARE_PURCHASE_TERMS = 'consent_to_aftercare_purchase_terms';
  static CAIN_LAMARRE_CONSENT = 'cain_lamarre_consent';
}
